var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "115px",
    viewBox: "0 0 112 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8722A8A8-10A3-42D0-9648-9AFB737975F5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.906,114.812 C83.916038,114.812 105.812,92.916038 105.812,65.906 C105.812,60.7764848 112.464469,54.145677 111,49.5 C107.438621,38.20238 105.389224,9.10331989 95.5,3 C88.0429729,-1.6022441 40.4062776,3 31,3 C8.71858212,3 6.4001189,33.1200339 0.5,53.5 C-0.752138483,57.8250891 8,61.1773799 8,65.906 C8,92.916038 29.895962,114.812 56.906,114.812 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary-Navigation-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing-3-Month",
    transform: "translate(-716.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder___library_book_shelf_archive_3371910-copy-6",
    transform: "translate(716.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 56.906,
    cy: 65.906,
    r: 48.906
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder__computer_share_screen_share_5110608-(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DB0F37",
    fillRule: "nonzero",
    x: 40,
    y: 100,
    width: 22.4356,
    height: 13.872144
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.638944,92.274168 L14.35128,92.274168 L14.35128,47.915568 C14.35128,45.9637896 15.9481896,44.36688 17.899968,44.36688 L84.090256,44.36688 C86.0420344,44.36688 87.638944,45.9637896 87.638944,47.915568 L87.638944,92.274168 Z",
    id: "Path",
    fill: "#DBE2EA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.638944,87.168088 L14.35128,87.168088 L14.35128,96.772848 C14.35128,98.7246264 15.9481896,100.321536 17.899968,100.321536 L84.090256,100.321536 C86.0420344,100.321536 87.638944,98.7246264 87.638944,96.772848 L87.638944,87.168088 Z",
    id: "Path",
    fill: "#FF4D5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avatars",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,-1.94980234e-13 C6.33008578,-1.94980234e-13 -3.10264664e-12,6.33008578 -3.10264664e-12,14.0668573 C-3.10264664e-12,21.8036288 6.33008578,28.1337146 14.0668573,28.1337146 C21.8036288,28.1337146 28.1337146,21.8036288 28.1337146,14.0668573 C28.1337146,6.33008578 21.8036288,-1.94980234e-13 14.0668573,-1.94980234e-13 Z",
    id: "Path",
    fill: "#FF4D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,28.1337146 C17.5835716,28.1337146 20.8658383,26.9614765 23.2103145,24.8514479 C22.272524,21.1002859 18.5213621,19.6936002 14.0668573,19.6936002 C9.61235248,19.6936002 5.86119054,21.1002859 4.92340005,24.8514479 C7.26787626,26.9614765 10.550143,28.1337146 14.0668573,28.1337146 Z",
    id: "Path",
    fill: "#DB0F37"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.0668573,
    cy: 11.7223811,
    r: 4.68895243
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,-1.94980234e-13 C6.33008578,-1.94980234e-13 -3.10264664e-12,6.33008578 -3.10264664e-12,14.0668573 C-3.10264664e-12,21.8036288 6.33008578,28.1337146 14.0668573,28.1337146 C21.8036288,28.1337146 28.1337146,21.8036288 28.1337146,14.0668573 C28.1337146,6.33008578 21.8036288,-1.94980234e-13 14.0668573,-1.94980234e-13 Z",
    id: "Path",
    fill: "#FF4D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,28.1337146 C17.5835716,28.1337146 20.8658383,26.9614765 23.2103145,24.8514479 C22.272524,21.1002859 18.5213621,19.6936002 14.0668573,19.6936002 C9.61235248,19.6936002 5.86119054,21.1002859 4.92340005,24.8514479 C7.26787626,26.9614765 10.550143,28.1337146 14.0668573,28.1337146 Z",
    id: "Path",
    fill: "#DB0F37"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.0668573,
    cy: 11.7223811,
    r: 4.68895243
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,-4.96584107e-13 C6.33008578,-4.96584107e-13 -3.10365067e-12,6.33008578 -3.10365067e-12,14.0668573 C-3.10365067e-12,21.8036288 6.33008578,28.1337146 14.0668573,28.1337146 C21.8036288,28.1337146 28.1337146,21.8036288 28.1337146,14.0668573 C28.1337146,6.33008578 21.8036288,-4.96584107e-13 14.0668573,-4.96584107e-13 Z",
    id: "Path",
    fill: "#FF4D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0668573,28.1337146 C17.5835716,28.1337146 20.8658383,26.9614765 23.2103145,24.8514479 C22.272524,21.1002859 18.5213621,19.6936002 14.0668573,19.6936002 C9.61235248,19.6936002 5.86119054,21.1002859 4.92340005,24.8514479 C7.26787626,26.9614765 10.550143,28.1337146 14.0668573,28.1337146 Z",
    id: "Path",
    fill: "#DB0F37"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.0668573,
    cy: 11.7223811,
    r: 4.68895243
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(49.220768, 37.694704)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.774344,
    y1: 1.774344,
    x2: 1.774344,
    y2: 1.774344,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.774344,
    y1: 23.066472,
    x2: 1.774344,
    y2: 23.066472,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.774344,
    y1: 24.9212136,
    x2: 1.774344,
    y2: 30.42168,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688,
    strokeDasharray: "0.2090177136659622,10.45283843994141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(49.220768, 48.340768)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20.404956,
    y1: 0.887172,
    x2: 20.404956,
    y2: 0.887172,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0583672,
    y1: 21.1233128,
    x2: 8.2676384,
    y2: 24.1396976,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688,
    strokeDasharray: "0.2152279257774353,10.75944448471069"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.774344,
    y1: 12.420408,
    x2: 1.774344,
    y2: 12.420408,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(31.477328, 48.340768)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.887172,
    y1: 0.887172,
    x2: 0.887172,
    y2: 0.887172,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.2337608,
    y1: 21.1233128,
    x2: 13.0244896,
    y2: 24.1396976,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688,
    strokeDasharray: "0.2152279257774353,10.75944448471069"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.517784,
    y1: 12.420408,
    x2: 19.517784,
    y2: 12.420408,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.548688
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.ed129401c8b4a2b7daa9b1b98335b3fb.svg";
export { ForwardRef as ReactComponent };